module.exports = __webpack_public_path__ + "static/media/0310_Medium.de47ee8c.jpg";